import {
  AvatarProps,
  Box,
  BoxProps,
  IconButton,
  IconButtonProps,
  IconProps,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { DateIndicator } from "../../services/swagger";
import { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "react-i18next";

interface DateIndicatorButtonProps {
  boxProps?: BoxProps;
  iconButtonProps?: IconButtonProps;
  avatarProps?: AvatarProps;
  iconProps?: IconProps;
  size?: number;
  value: DateIndicator | undefined;
  onChange: (indicator: DateIndicator | "") => void;
}

export default function DateIndicatorButton(props: DateIndicatorButtonProps) {
  const { t } = useTranslation("Enums");
  const indicatorSymbol = {
    this: t("DateIndicator.This"),
    last: t("DateIndicator.Last"),
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeIndicator = (newIndicator: DateIndicator | "") => {
    props.onChange(newIndicator);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box {...props.boxProps}>
      <Menu
        anchorEl={anchorEl}
        elevation={1}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: { mt: 1 },
          },
        }}
      >
        <MenuItem onClick={() => handleChangeIndicator("")} disableRipple>
          {t("DateIndicator.Custom")}
        </MenuItem>
        {[DateIndicator.This, DateIndicator.Last].map((indicator) => {
          return (
            <MenuItem
              key={indicator}
              onClick={() => handleChangeIndicator(indicator)}
              disableRipple
            >
              {indicatorSymbol[indicator]}
            </MenuItem>
          );
        })}
      </Menu>
      <IconButton
        onClick={handleClick}
        sx={{ p: 0 }}
        {...props.iconButtonProps}
        disableRipple
      >
        <Stack direction="row" alignItems="center">
          <Typography
            fontSize={props.size}
            sx={{
              maxWidth: 100,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {props.value
              ? indicatorSymbol[props.value]
              : t("DateIndicator.Custom")}
          </Typography>
          <ArrowDropDownIcon color="disabled" />
        </Stack>
      </IconButton>
    </Box>
  );
}
